module.exports = __webpack_public_path__ + "img/hero4.97157a1b.png";